import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedFileDownload } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetTestResultsParams } from '@eggplant/types'

interface Props {
  configType: string
  params?: GetTestResultsParams
  onSuccess: () => void
}

const DownloadAiRunsRequest = ({
  configType,
  params,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/runs`

  const { requestParams } = useGetParamsWithSpaceId<GetTestResultsParams | undefined>(params)

  return (
    <AuthenticatedFileDownload
      fileType='text/csv'
      filename={configType + '_results.csv'}
      method='get'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default DownloadAiRunsRequest
